import { showControlTypeName } from '@/utils/control_type'
import { Col, Row } from 'antd'
import './../Checkpoints.style.less'
import { DATE_FORMAT } from '@/constant/date'
import { isObjectLike } from 'lodash'
import moment from 'moment'

type Props = {
  data: any
  editComponent?: any
}

function ControlTypeDate({ data, editComponent = null }: Props) {
  const renderEditCheckpoint = editComponent ? (
    <Col span={1}>{editComponent()}</Col>
  ) : (
    <></>
  )
  return (
    <Col span={24}>
      <div className="control-type-multi-select-container page-break-inside">
        <Col span={12}>
          <p className="label">{showControlTypeName(data)}</p>
        </Col>
        <Col span={11}>
          <Row>
            {data?.value && (
              <p className="value">
                {isObjectLike(data?.value)
                  ? ''
                  : moment(data?.value).format(DATE_FORMAT.DDMMYY)}
              </p>
            )}
          </Row>
        </Col>
        {renderEditCheckpoint}
      </div>
    </Col>
  )
}

export default ControlTypeDate
